import { render, staticRenderFns } from "./orderIndex.vue?vue&type=template&id=538c377c&scoped=true&"
import script from "./orderIndex.vue?vue&type=script&lang=js&"
export * from "./orderIndex.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "538c377c",
  null
  
)

export default component.exports